<!-- Navbar -->
<div class="bg-white">

    <HomeNavBar />
    

    <!-- Hero Section -->
    <div class=" px-3 mt-5 ">
        <div class="row">
            <div class="justify-content-center text-center col-md-8 mx-auto">
                <h2 class="text-start fw-bold ">Empowering Women , Youth & Persons with Disabilities.</h2>
                <p class=" text-start">Track South Africa's progress on national policies and
                    strategic plans. Access real-time data on <br> government initiatives advancing equality,
                    opportunity, and inclusion for all.</p>
            </div>
        </div>
    </div>

    <section class="gender-mainstreaming mb-3">
        <div class="container">
            <div class="row align-items-center">
                <!-- Cards Section - Full width on mobile, half on desktop -->
                <div class="px-2">
                    <div class="row g-3">
                        <!-- Each card takes half width on mobile, full width on larger screens -->
                        <div class="col-6 col-sm-3 col-lg-6">
                            <div class="dwypd-card active h-100">
                                <div class="icon orange-bg d-flex align-items-center justify-content-center">
                                    <i class="bi bi-bar-chart-line"></i>
                                </div>
                                <p class="fw-bold mb-1">18+</p>
                                <p class="mb-0 mt-2 text-center">Indicators Monitored</p>
                            </div>
                        </div>

                        <div class="col-6 col-sm-3 col-lg-6">
                            <div class="dwypd-card card h-100">
                                <div class="icon orange-bg d-flex align-items-center justify-content-center">
                                    <i class="bi bi-journal-text"></i>
                                </div>
                                <p class="fw-bold mb-1">6+</p>
                                <p class="mb-0 mt-2 text-center">Department Reporting</p>
                            </div>
                        </div>

                        <div class="col-6 col-sm-3 col-lg-6">
                            <div class="dwypd-card card h-100">
                                <div class="icon orange-bg d-flex align-items-center justify-content-center">
                                    <i class="bi bi-columns-gap"></i>
                                </div>
                                <p class="fw-bold mb-1">18</p>
                                <p class="mb-0 mt-2 text-center">Strategic pillars</p>
                            </div>
                        </div>

                        <div class="col-6 col-sm-3 col-lg-6">
                            <div class="dwypd-card card active h-100">
                                <div class="icon orange-bg d-flex align-items-center justify-content-center">
                                    <i class="bi bi-calendar"></i>
                                </div>
                                <p class="fw-bold mb-1">2024/2025</p>
                                <p class="mb-0 mt-2 text-center">Current Date Period</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>



    <div>
        <div class="d-flex flex-column align-items-center text-center mb-2 mt-5">
            <h3 class="fw-bold">Progress Dashboard</h3>
            <p class="text-xs">Select a dashboard to explore detailed indicators, trends, and departmental performance across each of
                DWYPD's focus areas.</p>
        </div>

        <div class="container-fluid px-5">

            <div class=" card bg-transparent border rounded-5 shadow-sm mt-2 ">

                <div class="card-header flex-column bg-transparent d-flex border-bottom policy-header">
                    <div class="header-icon d-flex align-items-center justify-content-center">
                        <i class="bi bi-people-fill"></i>
                    </div>
                    <h5 class="text-white">Youth Empowerment</h5>
                    <p class="text-xs">National Youth Policy 2030</p>
                </div>
                <div class="card-body ">
                    <p class="text-xs">Tracking progress on education, employment, health, and social development for young people aged
                        14-35.

                    </p>
                    <div class="Covers">
                        <h6 class="text-sart mb-3 text-xs">Covers</h6>
                        <ul class="list-unstyled text-start text-xxs">
                            <li class="mb-2"><i class="bi bi-check-circle-fill text-success me-2"></i>5 Policy
                                Priorities monitored</li>
                            <li class="mb-2"><i class="bi bi-check-circle-fill text-success me-2"></i>Education, skills
                                & second chances</li>
                            <li class="mb-2"><i class="bi bi-check-circle-fill text-success me-2"></i>Economic
                                transformation & jobs</li>
                            <li class="mb-2"><i class="bi bi-check-circle-fill text-success me-2"></i>Physical & mental
                                health</li>
                        </ul>
                    </div>
                </div>
                <div class="post-button-container">
                    <a href="/youth_empowerment"
                        class="btn btn-primary w-100 text-xs rounded-3 shadow-sm mb-3 text-decoration-none text-center">
                        View Dashboard
                    </a>
                </div>



            </div>

        </div>

        <div class="container-fluid px-5">

            <div class=" card bg-transparent border rounded-5 shadow-sm mt-2 ">

                <div class="card-header flex-column bg-transparent d-flex border-bottom policy-header">
                    <div class="header-icon d-flex align-items-center justify-content-center">
                        <i class="bi bi-shield-exclamation"></i>
                    </div>
                    <h5 class="text-white">Gender-Based Violence & Femicide</h5>
                    <p class="text-xs">National Strategic Plan on GBVF</p>
                </div>
                <div class="card-body px-4">
                    <p class="text-xs">Monitoring the national response to end gender-based violence and femicide across 6 strategic
                        pillars.

                    </p>
                    <div class="Covers">
                        <h6 class="text-sart mb-3 text-xs">Covers</h6>
                        <ul class="list-unstyled text-start text-xxs">
                            <li class="mb-2"><i class="bi bi-check-circle-fill text-success me-2"></i>6 Strategic Pillars</li>
                            <li class="mb-2"><i class="bi bi-check-circle-fill text-success me-2"></i>Accountability & coordination</li>
                            <li class="mb-2"><i class="bi bi-check-circle-fill text-success me-2"></i>
                                Prevention & social cohesion</li>
                            <li class="mb-2"><i class="bi bi-check-circle-fill text-success me-2"></i>Justice, safety & protection
</li>
                        </ul>
                    </div>
                </div>
                <div class="post-button-container">
                    <a href="/gbv"
                        class="btn btn-primary text-xs w-100 rounded-3 shadow-sm mb-3 text-decoration-none text-center">
                        View Dashboard
                    </a>
                </div>



            </div>

        </div>

        <div class="container-fluid px-5">

            <div class=" card bg-transparent border rounded-5 shadow-sm mt-2 ">

                <div class="card-header flex-column bg-transparent d-flex border-bottom policy-header">
                    <div class="header-icon d-flex align-items-center justify-content-center">
                        <i class="bi bi-universal-access"></i>
                    </div>
                    <h5 class="text-white">Persons with Disabilities</h5>
                    <p class="text-xs">WPRPD Implementation</p>
                </div>
                <div class="card-body px-4 ">
                    <p class="text-xs">Advancing inclusion and empowerment for persons with disabilities across government and society.
                    </p>

                    <div class="Covers">
                        <h6 class="text-sart text-xs mb-3">Covers</h6>
                        <ul class="list-unstyled text-start text-xxs">
                            <li class="mb-2"><i class="bi bi-check-circle-fill text-success me-2"></i>3 Strategic Areas</li>
                            <li class="mb-2"><i class="bi bi-check-circle-fill text-success me-2"></i>Promotion of equity</li>
                            <li class="mb-2"><i class="bi bi-check-circle-fill text-success me-2"></i>Employment opportunities</li>
                            <li class="mb-2"><i class="bi bi-check-circle-fill text-success me-2"></i>Ownership & participation</li>
                        </ul>
                    </div>



                </div>
                <div class="post-button-container">
                    <a href="/pwd"
                        class="btn btn-primary text-xs w-100 rounded-3 shadow-sm mb-3 text-decoration-none text-center">
                        View Dashboard
                    </a>
                </div>




            </div>
        </div>
    </div>

    <div class="px-5 mt-5">
        <h4 class="fw-bold mb-4"> About These Dashboards</h4>
        <p class="text-xs">The Department of Women, Youth and Persons with Disabilities (DWYPD) is committed to transparency and
            accountability in advancing the rights and <br> empowerment of women, youth, and persons with disabilities
            in South Africa.</p>
        <div class="public-dashboards my-4">
            <h6 class="text-start mb-3 fw-bold mb-4">These public dashboards provide citizens with direct access to monitor
                government progress on key <br>national policies and strategic frameworks:

            </h6>
            <ul class="list-unstyled text-start text-xs">
                <li class="mb-2">
                    <i class="bi bi-check-circle-fill text-success me-2"></i>
                    National Youth Policy 2030 - Creating opportunities for young South Africans
                </li>
                <li class="mb-2">
                    <i class="bi bi-check-circle-fill text-success me-2"></i>
                    NSP on GBVF 2020-2030 - Ending gender-based violence and femicide
                </li>
                <li class="mb-2">
                    <i class="bi bi-check-circle-fill text-success me-2"></i>
                    WPRPD Implementation - Advancing disability rights and inclusion
                </li>
            </ul>
        </div>

    </div>


    <div class="footer-background">
        <div class="space"></div>
        <footer class="footer-content text-white pt-5 pb-4">
        <div class="container text-center text-md-left">
            <div class="row text-center text-md-left">
            <div class="col-md-3 col-lg-3 col-xl-3 mx-auto">
                <h5 class="text-start font-weight-bold knowledgehub2 ">Services</h5>
                <br>
                <a href="https://recruitment.dwypd.gov.za/" class="text-start d-block text-white text-decoration-none mb-4">Careers</a>
                <a href="https://dwypd.gov.za/" class="text-start d-block text-white text-decoration-none mb-4">Government</a>
                <a href="https://sayouth.mobi/Home/Index/EN" class="text-start d-block text-white text-decoration-none mb-4">SA Youth</a>
                <a href="#" class="text-start d-block text-white text-decoration-none mb-4">Votes</a>
            </div>
            <div class="col-md-3 col-lg-2 col-xl-2 mx-auto">
                <h5 class="text-start font-weight-bold knowledgehub2">Get in touch</h5>
                <br>
                <a href="#" class="text-start d-block text-white text-decoration-none mb-4" target="_blank">Fedsure Forum
                Building<br>1st Floor <br>
                268 Lilian Ngoyi Street <br> Pretoria 0001 South Africa</a>
                <a href="tel:+27123590000" class="text-start d-block text-white text-decoration-none mb-4"> 012 359 0000
                </a>
                <a href="mailto:media@dwypd.gov.za" class="text-start d-block text-white text-decoration-none mb-4">Email Us
                : media@dwypd.gov.za</a>
            </div>

            </div>
            <hr class="mb-2">
            <div class="row align-items-center">
            <div class="text-center">
                <p>
                Copyright © 2026 All rights reserved by
                <strong>
                    <a href="https://engagenet.ai/" target="_blank" class="text-white">Engagenet</a>
                </strong>.
                </p>
            </div>
            </div>
        </div>
        </footer>
    </div>


</div>